import { showSyncErrorToast, showSyncSuccessToast } from '@/noto';
import type { NotoCreatorHandle } from '@dialpad/noto';

let syncErrorToast: NotoCreatorHandle | null = null;

/**
 * Show a toast for syncing a campaign
 * Used to simplify transitions between error and success states
 * for all components that modify a campaign
 * Both sync toasts has mergeRelated enabled
 * So we can safely store only one link to the error toast
 */
export const showCampaignSyncToast = async (
  success: boolean,
): Promise<void> => {
  if (success) {
    if (syncErrorToast) {
      syncErrorToast.close();
    }
    void showSyncSuccessToast({
      content: {
        title: {
          key: 'TOAST_CAMPAIGN_UPDATED_TITLE',
        },
      },
    });
  } else {
    syncErrorToast = await showSyncErrorToast({});
  }
};
